import { LegalPage } from "../../components/LegalPage";

export function Hipaa() {
  return (
    <LegalPage
      title="HIPAA compliance"
      eyebrow="Trust center"
      description="WeConsult Rx HIPAA compliance overview: §164.308 administrative, .310 physical, .312 technical safeguards. BAA, Safe Harbor de-identification, breach notification."
      path="/hipaa"
      effective="2026-05-30"
    >
      <p>
        WeConsult Rx is a Business Associate under HIPAA. We execute a Business
        Associate Agreement with every customer (covered entity or business
        associate) before any PHI is processed on our platform.
      </p>

      <h2>HIPAA controls — overview</h2>
      <h3>Administrative safeguards (§164.308)</h3>
      <ul>
        <li>Security management process, including risk analysis and management.</li>
        <li>Assigned security responsibility (CISO / Security Officer).</li>
        <li>Workforce security: termination procedures, sanction policy.</li>
        <li>Information access management (role-based access).</li>
        <li>Security awareness training (annual + new hire).</li>
        <li>Security incident procedures with breach notification within BAA windows.</li>
        <li>Contingency plan: data backup, disaster recovery, emergency mode.</li>
        <li>Annual evaluation against §164.308.</li>
      </ul>

      <h3>Physical safeguards (§164.310)</h3>
      <ul>
        <li>Facility access controls inherited from AWS (Supabase + Bedrock) — SOC 2 Type II.</li>
        <li>Workstation use and security policy for staff devices.</li>
        <li>Device and media controls: encrypted laptops, secure disposal.</li>
      </ul>

      <h3>Technical safeguards (§164.312)</h3>
      <ul>
        <li>Access control — unique user IDs, automatic logoff, encryption.</li>
        <li>Audit controls — append-only audit log (7-year retention).</li>
        <li>Integrity — RLS, append-only audit, version control.</li>
        <li>Person or entity authentication — JWT + MFA for staff.</li>
        <li>Transmission security — TLS 1.2+, signed webhooks, HMAC verification.</li>
      </ul>

      <h2>Safe Harbor de-identification</h2>
      <p>
        Before any chart data is sent to a third-party LLM (AWS Bedrock), we
        apply the 18-identifier Safe Harbor de-identification standard
        (§164.514(b)(2)). De-identification events are logged.
      </p>
      <ul>
        <li>Names, addresses, ZIP codes more granular than first 3 digits</li>
        <li>All dates more specific than year (with ages 90+ aggregated)</li>
        <li>Phone, fax, email, SSN</li>
        <li>Medical record numbers (replaced with hashed UUIDs)</li>
        <li>Account numbers, license numbers, vehicle identifiers</li>
        <li>Device identifiers, URLs, IP addresses</li>
        <li>Biometric identifiers, full-face photographs</li>
        <li>Any other unique identifying number / characteristic / code</li>
      </ul>

      <h2>Breach notification</h2>
      <p>
        We notify affected customers per the BAA executed with that customer.
        For confirmed breaches affecting unsecured PHI, notification occurs
        without unreasonable delay and no later than 60 days from discovery
        (§164.410).
      </p>

      <h2>Minimum necessary</h2>
      <p>
        Our application implements the minimum necessary standard
        (§164.502(b)). UI surfaces only the fields a role needs; the database
        only stores the fields a workflow requires; audit metadata excludes
        PHI by gate test.
      </p>

      <h2>BAA</h2>
      <p>
        Our standard Business Associate Agreement is available for review at{" "}
        <a href="/baa">/baa</a>. We countersign within one business day.
      </p>
    </LegalPage>
  );
}
